import SockJS from 'sockjs-client';
import webstomp from 'webstomp-client';
import stateLogger from '../utils/StateLogger';

class FreespaceRealtime {
  authKey;

  base;

  destinations = [];

  stompClient = null;

  listeners = [];

  heartbeatListeners = null;

  lastBeat = 0;

  lastChecked = 0;

  connectionStatus = false;

  debug = false;

  baseUrl= 'https://prodws.afreespace.com'//'https://accountws.afreespace.com';

  constructor(authKey, base, debug) {
    this.authKey = authKey;
    this.base = base;
    if (debug) {
      this.debug = true;
    }
    setInterval(this.handleDiconnect.bind(this), 1000);
  }

  handleDiconnect() {
    const curr = Date.now();
    const previousStatus = this.connectionStatus;
    
    if (this.stompClient && this.stompClient.serverActivity) {
      this.lastBeat = Math.max(this.stompClient.serverActivity, this.lastBeat);
    }
    if (!navigator.onLine) {
      this.connectionStatus = 'offline';
    } else if (this.lastChecked === 0) {
      this.connectionStatus = 'init';
    } else if (this.stompClient === null) {
      this.connectionStatus = 'wait';
    } else if (!this.stompClient.serverActivity) {
      this.connectionStatus = 'try';
    } else if (curr - this.lastBeat > 30000) { // this.stompClient.connected === false if heartbeat working
      this.connectionStatus = 'disconnected';
    } else {
      this.connectionStatus = 'online';
    }
    
    // Log connection status changes
    if (previousStatus !== this.connectionStatus) {
      stateLogger.logConnectionStatus('LEGACY_SOCKET', this.connectionStatus, {
        lastBeat: this.lastBeat,
        currentTime: curr,
        timeSinceLastBeat: curr - this.lastBeat,
        previousStatus,
        destinations: this.destinations
      });
    }
    
    if (this.connectionStatus !== 'online' && navigator.onLine && this.lastChecked !== 0 && curr - this.lastChecked > 30000) {
      setTimeout(this.connect(), 100);
    }
    if (this.debug) {
      console.debug(`@${curr}, ${this.lastBeat}, ${this.connectionStatus}`);
    }
  }

  connect() {
    this.lastChecked = Date.now();
    if (this.stompClient) {
      this.stompClient.disconnect();
      this.stompClient = null;
    }
    const socket = new SockJS(`${this.base}/socket`);
    // SockJS has hijcked the onmessage interface to implement this
    socket.onheartbeat = function () {
      this.lastBeat = Date.now();
      this.heartbeatListeners(this.lastBeat);
      if (this.debug) {
        console.debug('NOW IN  HeartBeat');
      }
    }.bind(this);

    /* These are taken over by webstomp
  socket.onopen = function() {
     console.debug('NOW IN open');
     socket.send('test');
    };
     socket.onmessage = function(e) {
         console.debug('NOW IN  message', e.data);
         socket.close();
     };
  socket.onclose = function() {
             console.debug('NOW IN  Socket disconnected:close');
             setTimeout(this.handleDiconnect.bind(this), 10000);
    }; */

    const stompClient = webstomp.over(socket, { debug: this.debug });
    stompClient.connect({
      'X-Auth-Key': this.authKey,
    }, frame => {
      this.stompClient = stompClient;
      this.destinations.forEach(destination => {
        this.stompClient.subscribe(destination, event => {
          if (this.debug) {
            console.debug('Event', event);
          }
          this.publish(event.body);
        });
      });
    }, error => {
      console.warn('Socket disconnected');
    });
  }

  publish(msg) {
    const messages = msg.split(':').map(m => {
      const parts = m.split(',');
      const message = {};
      message.spaceId = parseInt(parts[0], 10);
      message.state = parseInt(parts[1], 10);
      message.source = 'POLICY';
      if (parts.length > 2) {
        message.id = parseInt(parts[2], 10);
        message.timestamp = message.id;
        if (parts.length > 3) {
          message.utcEpoch = parseInt(parts[3], 10);
        }
      }
      console.debug(JSON.stringify(message));
      return message;
    });
    for (let i = 0; i < this.listeners.length; i++) {
      for (let j = 0; j < messages.length; j++) {
        this.listeners[i](messages[j]);
      }
    }
  }

  subscribe(callback) {
    this.listeners.push(callback);
  }

  sendSocketHeartbeat(callback) {
    this.heartbeatListeners = callback;
  }
}

export default FreespaceRealtime;
